import { z } from 'zod';

export const animationVariantSchema = z.union([
    z.literal('Christmas'),
    z.literal('Halloween'),
    z.literal('Celebration'),
    z.literal('Olympics'),
    z.literal('Maythefourth'),
    z.literal('Spring'),
    z.literal('MusicFestival'),
    z.literal('EasterEggs'),
    z.literal('CustomAnimation'),
]);
export type AnimationVariant = z.infer<typeof animationVariantSchema>;

export const animationConfigurationTypeSchema = z.object({
    name: animationVariantSchema,
    activeClickEffect: z.number(),
    activeDecor: z.number(),
    auto: z.boolean(),
    audience: z.array(z.string()),
});
export type AnimationConfigurationType = z.infer<typeof animationConfigurationTypeSchema>;

export const animationStatsRowSchema = z.object({
    date: z.string(),
    number: z.number(),
});
export type AnimationStatsRow = z.infer<typeof animationStatsRowSchema>;

export const animationStatsSchema = z.object({
    id: z.number(),
    mainType: z.string(),
    type: z.string(),
    uri: z.string(),
    dateCreation: z.string().nullable(),
    dateModified: z.string().nullable(),
    animationName: z.string(),
    dateStart: z.string(),
    dateEnd: z.string().nullable(),
    auto: z.boolean(),
    stats: z.array(animationStatsRowSchema),
    animAudience: z.array(z.string()),
});
export type AnimationStats = z.infer<typeof animationStatsSchema>;
